import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ChromePicker } from 'react-color';

const HexColorDialog = ({ show, onHide, onSave }) => {
  const [color, setColor] = useState('#194d33');

  const handleChange = (colorResult) => {
    setColor(colorResult.hex);
  };

  const handleSave = () => {
    onSave(color);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="compact-color-modal"
      contentClassName="p-2 border-0"
    >
      <Modal.Header closeButton className="border-0 pb-2">
        <Modal.Title as="h5">Select a Color</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center p-2">
        <ChromePicker color={color} onChange={handleChange} />
      </Modal.Body>
      <Modal.Footer className="border-0 pt-2 pb-3 d-flex justify-content-center">
        <Button style={{background:"#7C5869"}} size="md" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HexColorDialog;
